"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "getTeam", {
  enumerable: true,
  get: function get() {
    return _getTeam["default"];
  }
});
var _getTeam = _interopRequireDefault(require("./getTeam"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }